// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-wrapper[data-v-1664e42c]{background-color:#fff;padding:3rem;margin-bottom:3rem}@media screen and (min-width:768px){.panel-wrapper[data-v-1664e42c]{border-radius:8px;box-shadow:1px 2px 3px #d6d1d1}}", ""]);
// Exports
module.exports = exports;
